import Enum from '_u/enum'

const FORM_MODE = Enum.get('FORM_MODE')

// 表单页面，通用逻辑
export default {
    props: {
        formMode: {
            type: [String, Number],
            default: FORM_MODE.add,
        },
    },
    data() {
        return {
            loading: true,
            FORM_MODE,
        }
    },
    computed: {
        // 是否新增模式
        isAdd() {
            return this.formMode === FORM_MODE.add ? true : false
        },
        // 是否修改模式
        isUpdate() {
            return this.formMode === FORM_MODE.update ? true : false
        },
        // 是否查看模式
        isView() {
            return this.formMode === FORM_MODE.view ? true : false
        },
    },
}
